import { Component, input } from '@angular/core';
import { ButtonModule } from '../../button/button.module';
import { IconModule } from '../../icon/icon.module';

@Component({
  selector: 'lib-blockering-sida',
  standalone: true,
  imports: [IconModule, ButtonModule],
  templateUrl: './blockering-sida.component.html',
  styleUrl: './blockering-sida.component.scss',
})
export class BlockeringSidaComponent {
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  readonly link = input<{ title: string; url: string }>();
  readonly titleIcon = input.required<string>();

  gaTillForhandsgranska(): void {
    if (this.link()) globalThis.location.href = this.link().url;
  }
}
